import { ProductData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const productsApi = apiResource<ProductData>('products');
